import React, { Component, Fragment } from "react";
import ReportScope, { readReportScope } from '../reports/report-scope';
import { injectIntl } from "react-intl";
import { DatePicker, RangeDatePicker } from "jalali-react-datepicker";
import API from "../../api/index";
var classNames = require("classnames");
import ReactTimeAgo from "react-time-ago";
import { NotificationManager } from "Components/ReactNotifications";
import moment from "jalali-moment";

import { logoutUser } from "Redux/actions";
import { connect } from "react-redux";

import { Row, Card, CardBody, CardTitle, Button, Collapse, FormGroup, Label, Input, Form, timeoutsShape } from "reactstrap";

import NumberFormat from "react-number-format";
import { Colxx, Separator } from "Components/CustomBootstrap";

class archive extends Component {
	constructor(props) {
		super(props);

		this.state = {
			orders: [],
			paging: [],
			isRefreshing: false,
			isLoading: true,
			toggleSearchForm: false,
			APIResetData: {},
			APISearchData: {},
			search: {
				reportContext: readReportScope(props.location.search),
				orderNumber: "",
				customerMobile: "",
				customerName: "",
				customerSurName: "",
				status: "ALL",
				createdFrom: "",
				createdTo: "",
				closedFrom: "",
				closedTo: "",
				currentPage: 1,
			},
		};

		this.validateMobile = this.validateMobile.bind(this);
		this.setCreatedDateRange = this.setCreatedDateRange.bind(this);
		this.setClosedDateRange = this.setClosedDateRange.bind(this);
		this.handleFocus = this.handleFocus.bind(this);
		this.toggleSearchForm = this.toggleSearchForm.bind(this);
		this.doSearch = this.doSearch.bind(this);
		this.doReset = this.doReset.bind(this);
		this.cleanCustomerMobile = this.cleanCustomerMobile.bind(this);
		this.loadData = this.loadData.bind(this);
	}

	cleanCustomerMobile(mobile) {
		mobile = mobile.split(" ").join("");
		mobile = mobile.replace(/[٠-٩]/g, (d) => "٠١٢٣٤٥٦٧٨٩".indexOf(d)).replace(/[۰-۹]/g, (d) => "۰۱۲۳۴۵۶۷۸۹".indexOf(d));

		// console.log(mobile,mobile.indexOf("0098"))
		if (mobile.indexOf("0098") === 0) {
			mobile = mobile.replace("0098", "0");
		}
		if (mobile.indexOf("098") === 0) {
			mobile = mobile.replace("098", "0");
		}
		if (mobile.indexOf("+98") === 0) {
			mobile = mobile.replace("+98", "0");
		}
		if (mobile.indexOf("98") === 0) {
			mobile = mobile.replace("98", "0");
		}
		if (mobile.indexOf("9") === 0 && mobile.length == 10) {
			mobile = "0" + mobile;
		}
		return mobile;
	}
	componentDidMount() {
		if (this.props.match.params.customerMobile != undefined) {
			const customerMobile = this.props.match.params.customerMobile;
			var cleanValue = this.cleanCustomerMobile(customerMobile);
			var tmpObj = { ...this.state.search };
			tmpObj.customerMobile = cleanValue;
			this.setState({ search: tmpObj,toggleSearchForm:true }, () => {
				this.setState(
					{
						APISearchData: JSON.parse(JSON.stringify(this.state.search)),
						APIResetData: JSON.parse(JSON.stringify(this.state.search)),
					},
					() => {
						this.loadData();
					}
				);
			});
		} else {
			this.setState(
				{
					APISearchData: JSON.parse(JSON.stringify(this.state.search)),
					APIResetData: JSON.parse(JSON.stringify(this.state.search)),
				},
				() => {
					this.loadData();
				}
			);
		}
	}
	loadData() {
		this.setState({ reportError: '' });
		API.order
			.archive(this.state.APISearchData)
			.then((data) => {
				data.RELOGIN ? this.props.logoutUser(this.props.history) : 0;
				this.setState({
					orders: data.orders,
					paging: data.paging,
					isLoading: false,
					isRefreshing: false,
				});
			})
			.catch((error) => { this.setState({ isLoading: false, isRefreshing: false, reportError: 'دریافت فهرست ناموفق بود؛ دسترسی یا فیلتر گزارش را بررسی کنید.', paging: {pages:[],total:0,from:0,to:0,current:1}, orders:[],customers:[],leads:[],coupons:[] }); });
	}
	doSearch() {
		var tmpObj = JSON.parse(JSON.stringify(this.state.search));
		tmpObj.currentPage = 1;
		this.setState(
			{
				APISearchData: tmpObj,
				isRefreshing: true,
			},
			() => {
				this.loadData();
			}
		);
	}
	doReset() {
		this.setState(
			{
				search: JSON.parse(JSON.stringify(this.state.APIResetData)),
				APISearchData: JSON.parse(JSON.stringify(this.state.APIResetData)),
				isRefreshing: true,
			},
			() => {
				this.loadData();
			}
		);
	}
	handleFocus = (event) => event.target.select();
	setCreatedDateRange(start, end) {
		var tmpObj = this.state.search;
		tmpObj.createdFrom = start;
		tmpObj.createdTo = end;
		this.setState({ search: tmpObj });
	}
	setClosedDateRange(start, end) {
		var tmpObj = this.state.search;
		tmpObj.closedFrom = start;
		tmpObj.closedTo = end;
		this.setState({ search: tmpObj });
	}
	validateMobile(mobile) {
		if (mobile.trim() == "") {
			return false;
		}
		return mobile.match(/^(0)+(9|$)\d{9}$/g) != null;
	}
	toggleSearchForm() {
		const prevState = this.state.toggleSearchForm;
		this.setState({
			toggleSearchForm: !prevState,
		});
	}

	render() {
		return this.state.isLoading ? (
			<div className="loading"></div>
		) : (
			<Fragment>
				<Row className="mb-4 searchdropdown">
					<Colxx xxs="12">
						<Card>
							<CardBody>
								<ReportScope scope={this.state.search.reportContext} error={this.state.reportError} />
								<CardTitle>
									<div className={"iconsminds-data-center headingicon"} />
									آرشیو و جستجوی سفارش‌ها
									<div className={"text-muted"} style={{ float: "left", fontSize: "14px" }}>
										نمایش {this.state.paging.from + 1} - {this.state.paging.to} از {this.state.paging.total} سفارش
									</div>
								</CardTitle>

								<Fragment>
									<div className="border productPanel">
										<Button block color="link" className="text-right" onClick={() => this.toggleSearchForm()} aria-expanded={this.state.toggleSearchForm}>
											<i className="glyph-icon simple-icon-magnifier" style={{ marginLeft: "5px", fontSize: "14px" }}></i>
											فرم جستجو
											<i className="glyph-icon simple-icon-arrow-down" style={{ marginRight: "10px", fontSize: "10px" }}></i>
										</Button>
										<Collapse isOpen={this.state.toggleSearchForm}>
											<div className="p-4">
												<Row className="mb-4">
													<Colxx xxs="12">
														<Form>
															<FormGroup row>
																<Colxx sm={3}>
																	<FormGroup className={"filter " + (parseInt(this.state.search.orderNumber) > 0 ? "filter-active" : "")}>
																		<Label for="ordernumber">شماره سفارش</Label>
																		<Input
																			type="text"
																			name="ordernumber"
																			placeholder="0000"
																			id="ordernumber"
																			onClick={this.handleFocus}
																			value={this.state.search.orderNumber}
																			onChange={(e) => {
																				var tmpObj = { ...this.state.search };
																				tmpObj.orderNumber = e.target.value.replace(/[٠-٩]/g, (d) => "٠١٢٣٤٥٦٧٨٩".indexOf(d)).replace(/[۰-۹]/g, (d) => "۰۱۲۳۴۵۶۷۸۹".indexOf(d));
																				this.setState({ search: tmpObj });
																			}}
																		/>
																	</FormGroup>
																	<FormGroup className={"filter " + (this.state.search.status != "ALL" ? "filter-active" : "")}>
																		<Label>وضعیت</Label>
																		<Input
																			type="select"
																			onChange={(e) => {
																				var tmpObj = { ...this.state.search };
																				tmpObj.status = e.target.value;
																				this.setState({ search: tmpObj });
																			}}
																			value={this.state.search.status}
																		>
																			<option value="ALL">همه وضعیت ها</option>
																			<option value="SUCCESS">فقط تحویل شده ها</option>
																			<option value="FAILED">فقط کنسلی ها</option>
																		</Input>
																	</FormGroup>
																</Colxx>
																<Colxx sm={3}>
																	<FormGroup className={"filter " + (this.validateMobile(this.state.search.customerMobile) ? "filter-active" : "")}>
																		<Label for="customermobile">موبایل مشتری</Label>
																		<Input
																			type="text"
																			name="customermobile"
																			id="customermobile"
																			onClick={this.handleFocus}
																			placeholder="09123456789"
																			value={this.state.search.customerMobile}
																			onChange={(e) => {
																				var cleanValue = this.cleanCustomerMobile(e.target.value);
																				var tmpObj = { ...this.state.search };
																				tmpObj.customerMobile = cleanValue;
																				this.setState({ search: tmpObj });
																			}}
																		/>
																	</FormGroup>
																	<FormGroup
																		className={
																			"filter " +
																			((this.state.search.customerName != "" && this.state.search.customerName.length > 2) || (this.state.search.customerSurName != "" && this.state.search.customerSurName.length > 2)
																				? "filter-active"
																				: "")
																		}
																	>
																		<Label for="customername">نام مشتری:</Label>
																		<br />
																		<Input
																			type="text"
																			name="customername"
																			id="customername"
																			onClick={this.handleFocus}
																			placeholder=" نام"
																			style={{ width: "calc(50% - 5px)", display: "inline-block", marginLeft: "5px" }}
																			value={this.state.search.customerName}
																			onChange={(e) => {
																				var tmpObj = { ...this.state.search };
																				tmpObj.customerName = e.target.value;
																				this.setState({ search: tmpObj });
																			}}
																		/>
																		<Input
																			type="text"
																			name="customersurname"
																			id="customersurname"
																			onClick={this.handleFocus}
																			placeholder="  نام خانوادگی"
																			style={{ width: "calc(50% - 5px)", display: "inline-block" }}
																			value={this.state.search.customerSurName}
																			onChange={(e) => {
																				var tmpObj = { ...this.state.search };
																				tmpObj.customerSurName = e.target.value;
																				this.setState({ search: tmpObj });
																			}}
																		/>
																	</FormGroup>
																</Colxx>

																<Colxx sm={2}>
																	<FormGroup className={"filter " + (this.state.search.createdFrom != "" && this.state.search.createdTo != "" ? "filter-active" : "")}>
																		<Button
																			style={{
																				float: "left",
																				padding: "5px",
																				color: "black",
																				backgroundColor: "transparent",
																				border: "unset",
																				display: this.state.search.createdFrom != "" && this.state.search.createdTo != "" ? "block" : "none",
																			}}
																			onClick={(e) => {
																				var tmpObj = { ...this.state.search };
																				tmpObj.createdFrom = "";
																				tmpObj.createdTo = "";
																				this.setState({ search: tmpObj });
																			}}
																		>
																			<i className="simple-icon-close"></i>
																		</Button>
																		<RangeDatePicker fromLabel="ثبت شده از تاریخ" toLabel="ثبت شده تا تاریخ" onClickSubmitButton={this.setCreatedDateRange} />
																	</FormGroup>
																</Colxx>
																<Colxx sm={2}>
																	<FormGroup className={"filter " + (this.state.search.closedFrom != "" && this.state.search.closedTo != "" ? "filter-active" : "")}>
																		<Button
																			style={{
																				float: "left",
																				padding: "5px",
																				color: "black",
																				backgroundColor: "transparent",
																				border: "unset",
																				display: this.state.search.closedFrom != "" && this.state.search.closedTo != "" ? "block" : "none",
																			}}
																			onClick={(e) => {
																				var tmpObj = { ...this.state.search };
																				tmpObj.closedFrom = "";
																				tmpObj.closedTo = "";
																				this.setState({ search: tmpObj });
																			}}
																		>
																			<i className="simple-icon-close"></i>
																		</Button>
																		<RangeDatePicker fromLabel="بسته شده از تاریخ" toLabel="بسته شده تا تاریخ" onClickSubmitButton={this.setClosedDateRange} />
																	</FormGroup>
																</Colxx>
																<Colxx sm={1}>
																	<br />
																	<br />
																	<br />
																	<br />
																	<br />
																	<br />
																	<br />
																	<Button color="light" style={{ float: "left", marginLeft: "10px" }} className={"default"} onClick={this.doReset}>
																		ریست
																	</Button>
																</Colxx>
																<Colxx sm={1}>
																	<br />
																	<br />
																	<br />
																	<br />
																	<br />
																	<br />
																	<br />
																	<Button color="primary" style={{ float: "left" }} className={"default"} onClick={this.doSearch}>
																		جستجو کن
																	</Button>
																</Colxx>
															</FormGroup>
														</Form>
													</Colxx>
												</Row>
											</div>
										</Collapse>
									</div>
									<br />
								</Fragment>
								{!this.state.isRefreshing ? (
									<div className="table-responsive">
										<table className="table table-hover order-table">
											<thead>
												<tr>
													<th>شماره سفارش</th>
													<th>زمان ثبت</th>
													<th>زمان تحویل / کنسل</th>
													<th>موبایل</th>
													<th>نام مشتری </th>
													<th>مبلغ سفارش </th>
													<th>نوع سفارش</th>
													<th>نحوه پرداخت</th>
													<th>وضعیت نهایی</th>
													<th>اپراتور</th>
												</tr>
											</thead>

											{this.state.orders.map((row) => (
												<TableBodyRows key={row.OrderId} data={row} />
											))}

											<tfoot>
												<tr>
													<td colSpan={12}>
														<div className="table-pagination">
															{this.state.paging.pages.map((page, index) => (
																<Button
																	key={index}
																	className={classNames({ "mb-2": true, "pagination-item": true, "pagination-number": true, "pagination-current": page.current })}
																	onClick={(e) => {
																		if (page.ellipse) {
																			return;
																		}
																		var tmpObj = { ...this.state.APISearchData };
																		tmpObj.currentPage = page.page;
																		// console.log(page.page, tmpObj.currentPage);
																		this.setState({ APISearchData: tmpObj, isRefreshing: true }, () => {
																			this.loadData();
																		});
																	}}
																>
																	{page.page}
																</Button>
															))}
														</div>
													</td>
												</tr>
											</tfoot>
										</table>
									</div>
								) : (
									<div className="loading" style={{ left: "unset", top: "unset", position: "relative", display: "block", marginLeft: "auto", marginRight: "auto" }}></div>
								)}
							</CardBody>
						</Card>
					</Colxx>
				</Row>
			</Fragment>
		);
	}
}

class TableBodyRows extends Component {
	render() {
		const {
			data: { OrderId, OpenedAt, ClosedAt, CustomerMobile, CustomerFullName, Payable, OrderType, PaymentType, Result, OperatorName, deleting },
		} = this.props;
		var OrderTypesFa = { SHOP: "حضوری", SITE: "سایت", CHAT: "چت" };
		var PaymentsTypesFa = { SITE: "درگاه", CARD: "کارت", CASH: "نقد", POS: "پوز" };
		var ReultsFa = { SUCCESS: "تحویل شد", FAILED: "کنسل شد" };

		return (
			<tbody>
				<tr className={"order-spacer"}></tr>
				<tr className={"order-item"}>
					<td>
						<a href={"/app/orders/view-order/" + OrderId}>
							{" "}
							{OrderId} <div className={" simple-icon-arrow-left-circle icongotoorder"} />
						</a>
					</td>
					<td className={"text-muted"}>{moment(OpenedAt).locale("fa").format("DD / MMMM / YYYY - HH:mm")}</td>
					<td className={"text-muted"}>{ClosedAt && moment(ClosedAt).isValid() ? moment(ClosedAt).locale("fa").format("DD / MMMM / YYYY - HH:mm") : '—'}</td>
					<td>
						<a href={"/app/customers/view-customer/" + CustomerMobile}>
							{" "}
							{CustomerMobile} <div className={" simple-icon-arrow-left-circle icongotoorder"} />
						</a>
					</td>
					<td>
						<div
							className={classNames({
								tableheadingicon: true,
								"text-muted": true,
								"simple-icon-options": CustomerFullName.trim() == "",
							})}
						/>
						{CustomerFullName}
					</td>
					<td className={"text-muted"}>
						<NumberFormat style={{ textAlign: "center" }} value={Payable} className="text-muted" displayType={"text"} suffix={" تومان"} thousandSeparator={true} renderText={(value, prop) => <div>{value}</div>} />
					</td>
					<td className={"text-muted"}>{OrderTypesFa[OrderType]}</td>
					<td className={"text-muted"}>{PaymentsTypesFa[PaymentType]}</td>
					<td style={{ color: Result == "FAILED" ? "red" : "green" }}>{ReultsFa[Result]}</td>
					<td className={"text-muted"}>{OperatorName}</td>
				</tr>
			</tbody>
		);
	}
}

const mapStateToProps = ({ menu, settings }) => {
	return { logoutUser };
};
export default injectIntl(connect(mapStateToProps, { logoutUser })(archive));
// export default injectIntl(archive);
